import { render, staticRenderFns } from "./ModalEditTarifKarbaran.vue?vue&type=template&id=9f247a20&scoped=true&"
import script from "./ModalEditTarifKarbaran.vue?vue&type=script&lang=js&"
export * from "./ModalEditTarifKarbaran.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTarifKarbaran.vue?vue&type=style&index=0&id=9f247a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f247a20",
  null
  
)

export default component.exports